import type {ChannelType} from 'nutshell-graphql-types';
import type {
    GetLeadChannels_lead_channels_edges as ChannelEdge,
    GetLeadChannels_lead_channels_edges_sources as AdditionalSource,
    GetSources_sources_edges_node as Source,
} from 'nutshell-graphql-types';

export const getAddableSources = (
    sources: Source[],
    channels: ChannelEdge[],
    additionalSources: AdditionalSource[],
    channelValue?: ChannelType | null
): Source[] => {
    let filteredSources = sources;

    if (channelValue) {
        if (channelValue === null) {
            filteredSources = sources.filter((source) => !source.channel);
        } else {
            filteredSources = sources.filter(
                (source) => source.channel && source.channel.value === channelValue
            );
        }
    }

    return filteredSources
        .filter(
            (source) =>
                !additionalSources.find((additionalSource) => additionalSource.id === source.id)
        )
        .filter(
            (source) =>
                !channels.find(
                    (channel) => channel && channel.sources.find((s) => s.id === source.id)
                )
        );
};
